import { Box } from '@careguide/theme'
import styled from 'styled-components'
import css from '@styled-system/css'

export const Facet = styled(Box).attrs({ as: 'div' })`
  line-height: 22px;
  flex-basis: 47%;
  flex-grow: 0;
  ${css({
    color: 'gray.6',
    marginY: 2,

    '&:nth-child(odd)': {
      paddingRight: 2,
    },
  })}
`

export const Paragraph = styled(Box).attrs({ as: 'p' })`
  flex-basis: 100%;
  margin: 0 0 10px;
  ${css({
    color: 'gray.6',

    '&:nth-child(1)': {
      mt: 4,
    },
  })}
`
